module.exports = __webpack_public_path__ + "static/img/pricehubble2.4455a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/APRILYOS/pricehubble2.png
// module id = PbYv
// module chunks = 0